"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.forComponentState = exports.forComponentProps = exports.useSnapshotController = exports.useController = exports.withMutable = exports.withFuncs = void 0;
var react_1 = require("react");
var immutable_state_controller_1 = require("immutable-state-controller");
__exportStar(require("./components"), exports);
var immutable_state_controller_2 = require("immutable-state-controller");
Object.defineProperty(exports, "withFuncs", { enumerable: true, get: function () { return immutable_state_controller_2.withFuncs; } });
Object.defineProperty(exports, "withMutable", { enumerable: true, get: function () { return immutable_state_controller_2.withMutable; } });
function useController(value, setValue) {
    if (setValue === undefined) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var _a = react_1.useState(value), state = _a[0], setState = _a[1];
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useSnapshotController({ value: state, setValue: setState });
    }
    else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useSnapshotController({ value: value, setValue: setValue });
    }
}
exports.useController = useController;
function useSnapshotController(snapshot) {
    var currentSnapshotValue = react_1.useRef(snapshot.value);
    var currentSnapshotSetValue = react_1.useRef(snapshot.setValue);
    currentSnapshotValue.current = snapshot.value;
    currentSnapshotSetValue.current = snapshot.setValue;
    /* We use useMemo so that the controller doesn't change, so it doesn't trigger a re-render when we use it in deps in a component.
       We rely on something else to trigger re-renders, like the state that backs the controller changing.
     */
    var mainController = react_1.useMemo(function () {
        return immutable_state_controller_1.withFuncs(function () { return currentSnapshotValue.current; }, function (newValue) {
            currentSnapshotValue.current = newValue;
            currentSnapshotSetValue.current(newValue);
        });
    }, []);
    /* Because we reuse the same Controller instance if the snapshot value is the same,
       we must remove all of the change listeners as the render pass will add them again.
     */
    mainController.removeAllChangeListeners();
    return mainController;
}
exports.useSnapshotController = useSnapshotController;
function forComponentProps(component, valueProperty, onChangeProperty) {
    if (onChangeProperty === undefined || valueProperty === undefined) {
        var actualComponent_1 = component;
        return immutable_state_controller_1.withFuncs(function () { return actualComponent_1.props.value; }, actualComponent_1.props.setValue);
    }
    else {
        var actualComponent_2 = component;
        return immutable_state_controller_1.withFuncs(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function () { return actualComponent_2.props[valueProperty]; }, function (newValue) { return actualComponent_2.props[onChangeProperty](newValue); });
    }
}
exports.forComponentProps = forComponentProps;
function forComponentState(component, property) {
    if (property === undefined) {
        return immutable_state_controller_1.withFuncs(function () { return component.state; }, function (newValue) { return component.setState(function () { return newValue; }); });
    }
    else {
        return immutable_state_controller_1.withFuncs(function () { return component.state[property]; }, function (newValue) {
            component.setState(function (state) {
                var _a;
                return __assign(__assign({}, state), (_a = {}, _a[property] = newValue, _a));
            });
        });
    }
}
exports.forComponentState = forComponentState;
